import { ADD_BEIHILFE_LEGACY_HEADER_TOKEN } from './add-beihilfe-legacy-header.token';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderBeihilfeLegacyInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.context.get(ADD_BEIHILFE_LEGACY_HEADER_TOKEN) === true) {
      const modifiedReq = request.clone({
        headers: request.headers.set('Beihilfe-Legacy', '1'),
      });
      return next.handle(modifiedReq);
    }
    return next.handle(request);
  }
}
